import { render } from "./PageSidebar.vue?vue&type=template&id=aec23022&scoped=true"
import script from "./PageSidebar.vue?vue&type=script&lang=js"
export * from "./PageSidebar.vue?vue&type=script&lang=js"

import "./PageSidebar.vue?vue&type=style&index=0&id=aec23022&lang=scss&scoped=true"

import exportComponent from "D:\\projectAll\\DefectiveProduct\\BOSS_DPS\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aec23022"]])

export default __exports__